import React from "react";
import { Edit2, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { getSiteName, getStudyName } from "../../utils/helpers";
import { getVisitStatusColor, getVisitTypeDisplay, formatVisitDate } from "./visitHelpers";

export const VisitsTable = ({ visits, sites, studies, onEdit, onDelete }) => (
  <Card className="border-0 shadow-lg" data-testid="visits-table">
    <CardHeader><CardTitle>All Visits ({visits.length})</CardTitle></CardHeader>
    <CardContent className="p-0">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-left p-4 font-semibold text-gray-700">PI Name</th>
              <th className="text-left p-4 font-semibold text-gray-700">Site</th>
              <th className="text-left p-4 font-semibold text-gray-700">Study</th>
              <th className="text-left p-4 font-semibold text-gray-700">Visit Type</th>
              <th className="text-left p-4 font-semibold text-gray-700">Patient</th>
              <th className="text-left p-4 font-semibold text-gray-700">Date</th>
              <th className="text-left p-4 font-semibold text-gray-700">Status</th>
              <th className="text-left p-4 font-semibold text-gray-700">Contact</th>
              <th className="text-left p-4 font-semibold text-gray-700">Actions</th>
            </tr>
          </thead>
          <tbody>
            {visits.map((visit, idx) => (
              <tr key={visit.id} className={`border-b hover:bg-gray-50 ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-25'}`} data-testid={`visit-row-${visit.id}`}>
                <td className="p-4 font-medium text-gray-900">{visit.pi_name}</td>
                <td className="p-4 text-gray-600">{getSiteName(sites, visit.site_id)}</td>
                <td className="p-4 text-gray-600">{getStudyName(studies, visit.study_id)}</td>
                <td className="p-4"><Badge variant="outline" className="bg-blue-100 text-blue-800">{getVisitTypeDisplay(visit.visit_type)}</Badge></td>
                <td className="p-4 text-gray-600">{visit.patient_name}</td>
                <td className="p-4 text-gray-600">{formatVisitDate(visit.date)}</td>
                <td className="p-4"><Badge className={getVisitStatusColor(visit.status)}>{visit.status}</Badge></td>
                <td className="p-4 text-gray-600">{visit.contact}</td>
                <td className="p-4">
                  <div className="flex gap-2">
                    <Button size="sm" variant="outline" onClick={() => onEdit(visit)} className="hover:bg-blue-50" data-testid={`edit-visit-${visit.id}`}>
                      <Edit2 className="h-3 w-3" />
                    </Button>
                    <Button size="sm" variant="outline" onClick={() => onDelete(visit.id)} className="text-red-600 hover:text-red-700 hover:bg-red-50" data-testid={`delete-visit-${visit.id}`}>
                      <Trash2 className="h-3 w-3" />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
            {visits.length === 0 && (
              <tr>
                <td colSpan="9" className="p-8 text-center text-gray-500">No visits found. Try adjusting your filters or process emails to import visits.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);
